import React, { useState } from "react";
import {
  Box,
  Text,
  Button,
  Group,
  RingProgress,
  createStyles,
  Loader,
} from "@mantine/core";
import { IconFingerprint } from "@tabler/icons-react";
import { useGetTimeUtilization } from "api/attendance/gettodayTimeUtilization";
import { useAddPunchIn, Location } from "api/attendance/punchIn";
import PunchOutModal from "features/attendance-employees/components/punchOutModal";
import { getDeviceId } from "utils/deviceid";
import { getCurrentLocation } from "utils/devicegeolocation";
import { useUser } from "hooks/useUser";
import { useGetUser } from "api/users/getUser";

const useStyles = createStyles((theme) => ({
  card: {
    backgroundColor: theme.white,
    borderRadius: theme.radius.md,
    boxShadow: theme.shadows.sm,
    padding: 24,
    width: "33%",
    // maxWidth: 360,
  },
  ringWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  statsGroup: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing.md,
    width: "100%",
  },
  statItem: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
}));

export function PunchBtn() {
  const { classes } = useStyles();
  const userResult = useGetUser();
  const user: any = userResult || {}; // Provide fallback if null
  console.log(user, "this is user");
  const orgId = user?.data?.org?._id;
  const { data, isLoading } = useGetTimeUtilization();
  const { mutateAsync: addPunchIn, data: punchInResponse } = useAddPunchIn();
  const [opened, setOpened] = useState(false);
  const [loadingAction, setLoadingAction] = useState(false);

  const canPunchOut = data?.data?.canPunchOut ?? false;
  const punchInTime = data?.data?.punchInTime || "";
  let buttonContent;

  if (loadingAction) {
    buttonContent = <Loader size="xs" />;
  } else if (canPunchOut) {
    buttonContent = "Clock Out";
  } else {
    buttonContent = "Clock In";
  }
  const timeString = new Date(punchInTime).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  const handlePunchIn = async () => {
    setLoadingAction(true);
    try {
      const timestamp = new Date().toISOString();

      const deviceId = getDeviceId();

      let location: Location = { lat: 0, lng: 0 };

      try {
        const { lat, lng } = await getCurrentLocation();
        location = { lat, lng };
      } catch (geoError) {
        console.log(geoError);
      }
      const payload = {
        punchInTime: timestamp,
        source: "Web",
        deviceId,
        location,
      };

      await addPunchIn(payload);
    } catch (err) {
      console.error("Clock In Failed:", err);
    } finally {
      setLoadingAction(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <IconFingerprint color="green" size={24} />
        <Text weight={500} size="sm">
          Clock In: {canPunchOut ? timeString : ""}
        </Text>
      </div>
      {isLoading ? (
        <Box mt={20} style={{ display: "flex", justifyContent: "center" }}>
          <Loader size="sm" />
        </Box>
      ) : (
        <Button
          variant="filled"
          radius="md"
          size="sm"
          onClick={canPunchOut ? () => setOpened(true) : handlePunchIn}
          disabled={loadingAction}
        >
          {buttonContent}
        </Button>
      )}
      <PunchOutModal
        opened={opened}
        orgId={orgId}
        onClose={() => setOpened(false)}
      />
    </Box>
  );
}
